import React, { lazy, useRef, useState } from "react";

/** Common Components */
import CardSection from "../../components/ui/card/CardSection";
import CenterModal from "../../components/ui/centerModal/CenterModal";

/** CSS Files */
import "./UserManagement.scss";
import useDebounce from "../../app/customHooks/useDebounce";
import Label from "../../components/forms/ui/label/Label";
import SearchBar from "../../components/ui/searchBar/SearchBar";

/** Lazily Loaded Components */
const UsersList = lazy(() => import("./components/usersList/UsersList"));
const AddEditUser = lazy(() => import("./components/addEditUser/AddEditUser"));

const UserManagement = () => {

  const molGridRef = useRef();

  const [isEdit, setIsEdit] = useState(false);
  const [editUserData, setEditUserData] = useState(null);
  const [isUserModelOpen, setIsUserModelOpen] = useState(false);
  const [searchText, setsearchText] = useState("")
  const debouncedSearch = useDebounce(searchText, 300);

  const handleAddUserClick = () => {
    setIsUserModelOpen(true);
    setEditUserData(null);
    setIsEdit(false);
  };

  const handleCloseModel = () => {
    setIsUserModelOpen(false);
    setEditUserData(null);
    setIsEdit(false);
  };

  const handleEditClick = (data) => {
    setIsUserModelOpen(true);
    setEditUserData(data);
    setIsEdit(true);
  };

  const handleSuccess = () => {
    handleCloseModel();
    if (molGridRef.current) {
      molGridRef.current?.refreshGrid();
    }
  };

  const handleSearchChange = (e) => {
    let value = e?.target?.value
    setsearchText(value)

  }

  return (
    <>
      <div className="user-management">
        <CardSection cardTitle={"Filter Options"}>
          <div className="row">
            <div className="col-4">
              <Label labelName={"Name and Email :"} />
              <SearchBar 
              placeholder = {"Search by Name and Email address"}
              onChange={handleSearchChange} />
            </div>
          </div>
        </CardSection>
        <div className="second-section">
        <CardSection
          cardTitle={"Users"}
          rightButton={true}
          buttonClassName={"blue-btn"}
          titleButtonClick={handleAddUserClick}
          buttonText={"ADD"}
          searchInput={false}
          isButtonVisible={true}
          isButtonLoading={""}
          isIcon={true}
          iconClass="uil:plus"
          handleChange={handleSearchChange}
        >
          <div className="only-list-body-scroll">
            <UsersList ref={molGridRef}
              onEdit={handleEditClick}
              onSuccess={handleSuccess}
              search={debouncedSearch}
            />
          </div>
        </CardSection>
        </div>
      </div>
      <CenterModal
        modalTitle={isEdit ? `Update User` : `Add User`}
        modalSize={"w-50"}
        isOpen={isUserModelOpen}
        onClose={handleCloseModel}
        transition={"grow"}
      >
        <AddEditUser
          isEdit={isEdit}
          isOpen={isUserModelOpen}
          initData={editUserData}
          onClose={handleCloseModel}
          onSuccess={handleSuccess}
        />
      </CenterModal>
    </>
  );
};

export default UserManagement;
